angular.module('registraceServices', [])

.factory('Registrace', ["$http", "settings", function($http, settings) {

	var baseUrl = settings.g_anonymousRestUrl + "/registrace";

	return {
		registerStep0:function(data){
			return $http({
				method: 'POST',
				url: baseUrl + '/search-op',
				data: {'identificator':data.identificator,'captcha':data.captcha,'ref':data.ref},
				headers: {
					'Content-Type': 'application/json'
				}
			});
		},
		registerStep1: function(formData) {

			return $http({
				method: 'POST',
				url: baseUrl + '/basic-info',
				data: formData,
				headers: {
					'Content-Type': 'application/json'
				}
			});
		},
		registerStep2: function(formData) {

			return $http({
				method: 'POST',
				url: baseUrl + '/advanced-info',
				data: formData,
				headers: {
					'Content-Type': 'application/json'
				}
			});
		},
		sendSms: function(formData) {

			return $http({
				method: 'POST',
				url: baseUrl + '/sms',
				data: formData,
				headers: {
					'Content-Type': 'application/json'
				}
			});
		},
        getEmailRegex: function() {

            return $http({
                method: 'GET',
                url: baseUrl + '/email-regex',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        },
		getSiteKey: function() {
			return $http({
				method: 'GET',
				url: baseUrl + '/site-key',
				headers: {
					'Content-Type': 'application/json'
				}
			});
		}
	};
}])

.factory('Container', function() {
	var messages = {};
	var isCompany = false;
	var loginList = [];
	var formDataContainer = {
		step1: {},
		step2: {},
		sms: {}
	};
	var customized = false;
	var target = null;
    var ref = null;
	return {
		getMessages: function() {
			return messages;
		},
		setMessages: function(msgs) {
			messages = msgs;
		},
		isCompany: function() {
			return isCompany;
		},
		setCompany: function(bool) {
			isCompany = bool;
		},
		getLoginList: function() {
			return loginList;
		},
		setLoginList: function(list) {
			loginList = list;
		},
		setBasicInfo: function(formData) {
			formDataContainer.step1 = formData;
		},
		setAdvancedInfo: function(formData) {
			formDataContainer.step2 = formData;
		},
		setSms: function(formData) {
			formDataContainer.sms = formData;
		},
		getFormDataContainer: function() {
			return formDataContainer;
		},
		setCustomized: function() {
			customized = true;
		},
		getCustomized: function() {
			return customized;
		},
		setTarget: function(value) {
			target = value;
		},
		getTarget: function() {
			return target;
		},
		getRef: function () {
            return ref;
        },
        setRef: function (data) {
            ref = data;
        }

	};
});